import React, { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { FaDownload } from "react-icons/fa";
import API from "../../api";

// eslint-disable-next-line react/prop-types
const StatsRadialChart = ({ width = 300, height = 300 }) => {
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);

  const userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"));
  const annee_id = userAuthScolarite?.user?.annee_id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.post("emploi/stat_emploi_ens", { annee_id });
        const data = response.data.Statistiques;

        setLabels(Object.keys(data));
        setSeries(Object.values(data));
      } catch (error) {
        console.error("Erreur lors du chargement des statistiques :", error);
      }
    };

    fetchData();
  }, [annee_id]);

  const options = {
    chart: {
      id: "radialChartID", // 🟢 important pour ApexCharts.exec()
      type: "radialBar",
      height: height,
      toolbar: { show: false },
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        hollow: { size: "30%" },
        dataLabels: {
          name: { fontSize: "14px", color: "#888" },
          value: {
            fontSize: "16px",
            formatter: val => val,
          },
          total: {
            show: true,
            label: "Total",
            formatter: function (w) {
              const total = w.globals.series.reduce((a, b) => a + b, 0);
              return total;
            },
          },
        },
      },
    },
    // title: {
    //   // text: "Statistique des emplois enseignants",
    //   align: "center",
    //   style: { fontSize: "18px", color: "#333", fontWeight: "bold" },
    // },
    labels: labels.length ? labels : ["Chargement..."],
    colors: ["#1E90FF", "#FF6347", "#28a745", "#FFC107", "#9C27B0"],
  };

  const handleDownload = () => {
    ApexCharts.exec("radialChartID", "dataURI").then(({ imgURI }) => {
      const link = document.createElement("a");
      link.href = imgURI;
      link.download = "Statistique des emplois enseignants.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ color: "#FFC107" }}>Statistique des emplois enseignants</h3>
      <FaDownload
        onClick={handleDownload}
        title="Statistique des emplois enseignants"
        style={{
          cursor: "pointer",
          marginBottom: "10px",
          color: "#E91E63",
          fontSize: "20px",
        }}
      />
      <Chart
        options={options}
        series={series.length ? series : [0, 0, 0]}
        type="radialBar"
        width="100%"
        height={height}
      />
    </div>
  );
};

export default StatsRadialChart;
